export function isEntryArray(entry: unknown): entry is [string, string] {
  return Array.isArray(entry);
}
